import { Avatar, Flex, Tooltip } from '@chakra-ui/react'
import { iColaboradorBase } from '../../../../../interfaces'

interface iAvataresParticipantesProps {
  participantes?: iColaboradorBase[]
  responsavel?: iColaboradorBase
  max?: number
  size?: string
}

export const AvataresParticipantes: React.FC<iAvataresParticipantesProps> = ({ participantes, responsavel, max = 5, size = 'xs' }): JSX.Element | null => {
  const lista = (participantes ?? []).filter(p => p.id !== responsavel?.id)

  if (!responsavel && lista.length === 0) {
    return null
  }

  const visiveis = lista.slice(0, max)
  const ocultos = lista.slice(max)

  return (
    <Flex alignItems={'center'} flexShrink={0}>
      {responsavel && (
        <Tooltip
          label={`${responsavel.nome} (Responsável)`}
          hasArrow
          bg={'var(--Azul)'}
          color={'white'}
          borderRadius={'.25rem'}
          fontSize={'.8rem'}
          p={'.4rem .625rem'}
        >
          <Avatar
            size={size}
            name={responsavel.nome}
            src={responsavel.avatar}
            border={'2px solid var(--Azul)'}
            cursor={'default'}
          />
        </Tooltip>
      )}

      {visiveis.map((p, i) => (
        <Tooltip
          key={p.id}
          label={p.nome}
          hasArrow
          bg={'var(--Azul)'}
          color={'white'}
          borderRadius={'.25rem'}
          fontSize={'.8rem'}
          p={'.4rem .625rem'}
        >
          <Avatar
            size={size}
            name={p.nome}
            src={p.avatar}
            ml={(!responsavel && i === 0) ? '0' : '-0.4rem'}
            border={'2px solid var(--c1)'}
            cursor={'default'}
          />
        </Tooltip>
      ))}

      {ocultos.length > 0 && (
        <Tooltip
          label={ocultos.map(p => p.nome).join(', ')}
          hasArrow
          bg={'var(--Azul)'}
          color={'white'}
          borderRadius={'.25rem'}
          fontSize={'.8rem'}
          p={'.4rem .625rem'}
        >
          <Avatar
            size={size}
            name={`+${ocultos.length}`}
            getInitials={(nome) => nome}
            bg={'var(--c5)'}
            color={'var(--Gray1)'}
            ml={'-0.4rem'}
            border={'2px solid var(--c1)'}
            cursor={'default'}
          />
        </Tooltip>
      )}
    </Flex>
  )
}
